import React, {useEffect, useState} from 'react';
import {Button, Card, Flex, Input, Select, Space} from "antd";
import {BackButton, getProductSubCategoryList} from "../../../../shared";
import {StyledCard} from "./UserProductListHeader.styled";
import {useLocation} from "react-router-dom";
import {RiListCheck2} from "react-icons/ri";
import {IoLocationOutline} from "react-icons/io5";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";

const UserProductListHeader = () => {

    return (
        <StyledCard>
            <Flex vertical gap={"middle"}>
                <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                    <Flex gap={"small"} align={"center"}>
                        <BackButton/>
                        <span>آگهی های من</span>
                    </Flex>
                    <img width={20} src={require("assets/Logo/logoPink.png")}/>
                </Flex>

            </Flex>
        </StyledCard>
    )

};

export default connect(null, {getProductSubCategoryList})(withRouter(UserProductListHeader));
